import {
    WORKSPACE_MANUFACTURER_SELECTED_KEY,
    WorkspaceManufacturerSelected,
} from 'shared/utils/workspaceUtils'

export interface ExtractedElementIds {
    elementId: string | null
    nodeId: string | null
    source: 'service-worker' | 'message' | 'fallback'
}

/**
 * Extracts elementId and nodeId from service worker message data
 * Prioritizes elementId from addManufacturerProductListingElements.updatedInput.elementId
 * Falls back to workspaceManufacturerSelectedState values
 * For nodeId, checks both updatedInput and workspaceManufacturerSelectedState since updatedInput may not include it
 */
export const extractElementIds = (data: any): ExtractedElementIds => {
    // Primary source: service worker addManufacturerProductListingElements response
    const elementIdFromServiceWorker =
        data?.addManufacturerProductListingElements?.updatedInput?.elementId

    // Get workspace state for potential nodeId fallback
    const workspaceState = data?.[
        WORKSPACE_MANUFACTURER_SELECTED_KEY
    ] as WorkspaceManufacturerSelected

    if (elementIdFromServiceWorker) {
        // updatedInput may not have nodeId, so fallback to workspaceState.nodeId
        const nodeIdFromUpdatedInput = data?.addManufacturerProductListingElements?.updatedInput?.nodeId
        const nodeIdFallback = workspaceState?.nodeId || null

        return {
            elementId: elementIdFromServiceWorker,
            nodeId: nodeIdFromUpdatedInput || nodeIdFallback,
            source: 'service-worker',
        }
    }

    // Fallback: get from workspace manufacturer selected state
    if (workspaceState) {
        return {
            elementId: workspaceState.elementId || null,
            nodeId: workspaceState.nodeId || null,
            source: 'message',
        }
    }

    return {
        elementId: null,
        nodeId: null,
        source: 'fallback',
    }
}